<template>
  <div class="animated fadeIn">
    <b-card size="sm">
      <div slot="header">
        <i class="icon-note"></i> Set Qty Actual
      </div>

      <b-card-body v-if="status_spkb === 0">
        <b-row v-if="!loadingSubmit">
          <b-col sm="6">
            <b-form id="spkbForm" validated novalidate>
              <table
                class="table table-bordered table-striped table-responsive"
                style="width:100%;"
              >
                <thead>
                  <tr>
                    <th class="th-300px">Nama Produk</th>
                    <th class="th-105px text-center">Qty Plan</th>
                    <th class="th-300px">Qty Actual</th>
                    <th class="width-250">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(v, index) in spkb">
                    <tr :key="'looping'+index">
                      <td><div v-html="v.product_name"/></td>
                      <td class="text-center">{{v.qty_plan}}</td>
                      <td>
                        <b-form-group label :label-for="'id'+index">
                          <b-form-input
                            :key="'input-text'+index"
                            :type="'number'"
                            v-model="$v.spkb_actual.$each[index].qty.$model"
                            :max="v.qty_plan"
                            :isError="$v.spkb_actual.$each[index].qty.$invalid"
                            :min="0"
                          ></b-form-input>
                          <b-form-input
                            :key="'slider-input-text'+index"
                            :type="'range'"
                            v-model="$v.spkb_actual.$each[index].qty.$model"
                            :max="v.qty_plan"
                            :min="0"
                            :step="0"
                          ></b-form-input>
                          <div
                            class="text-muted"
                          >Qty Aktual: {{ $v.spkb_actual.$each[index].qty.$model }}</div>
                        </b-form-group>
                      </td>
                      <td class>Rp. {{formatPrice(v.total_price_plan)}}</td>
                    </tr>
                  </template>

                  <template>
                    <tr>
                      <td class="text-right">Total</td>
                      <td class="text-center">{{totalQty}}</td>
                      <td class="text-center">{{totalQtyActual}}</td>
                      <td>Rp. {{formatPrice(totalPriceActual)}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <div slot="modal-footer" class="float-right">
                <div v-if="!loadingSubmit">
                  <b-button type="button" size="sm" variant="danger" @click="back">
                    <i class="fa fa-undo"></i> Back
                  </b-button> 
                  &nbsp;
                  <b-button
                    type="submit"
                    size="sm"
                    variant="warning"
                    @click="doCancel"
                    :disabled="$v.spkb_actual.$invalid"
                  >
                    <i class="fa fa-ban"></i> Batal Kirim
                  </b-button>
                    &nbsp;
                  <b-button
                    type="submit"
                    size="sm"
                    variant="primary"
                    @click="doSomething"
                    :disabled="$v.spkb_actual.$invalid"
                  >
                    <i class="fa fa-save"></i> Save
                  </b-button>

                  
                </div>
              </div>
            </b-form>
          </b-col>

          <b-col sm="6">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>SPKB</th>
                  <th>Driver</th>
                  <th>Penanggung Jawab Faktur</th>
                  <th>Tanggal Pengiriman</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{spkb_number}}</td>
                  <td>{{getDriverName}}</td>
                  <td>{{getInvoicePIC}}</td>
                  <td>{{getDeliveryDate}}</td>
                </tr>
                <tr>
                  <td colspan="4">
                    <b-form-group label-for="product_group" label="Ubah Penanggung Jawab SPKB">
                        <vue-autosuggest
                          v-model="customers.text"
                          @inputout="focusMe"

                          :suggestions="filteredOptions"
                          @input="onInputChange"
                          @selected="onSelected"
                          :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control'}"
                          :limit="20"
                        >
                          <template slot-scope="{ suggestion }">
                            <span class="my-suggestion-item"> 
                              {{ suggestion.item.text }}
                            </span>
                          </template>
                        </vue-autosuggest>
                    </b-form-group>
                    <template>
                      <div>Penanggung jawab yang anda pilih:<br/> 
                        <strong>{{(customers.text !== null ) ? customers.text : '-'}}</strong>
                      </div>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <loading></loading>
          </b-col>
        </b-row>
      </b-card-body>

      <b-card-body v-else>
          <b-row>
            <b-col sm="12">
              <p class="text-center">No data available</p>
            </b-col>
          </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required, between } from "vuelidate/lib/validators";
import loading from "@/templates/Loading.vue";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/id";
import { VueAutosuggest } from 'vue-autosuggest';

const contains = function(min, max, value) {
  return value >= min || value <= max;
};

export default {
  name: "spkb_adjust_detail",
  components: {
    ModelSelect,
    loading,
    VueAutosuggest
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      spkb: [],
      spkb_actual: [],
      spkb_number: '',
      loadingSubmit: false,
      totalQty: 0,
      customers: {
        text: null,
        value: null
      },
      filteredOptions: [],
      suggestions: [
        {
          data: [],
        },
      ]
    };
  },
  validations: {
    spkb_actual: {
      required,
      $each: {
        qty: { required },
        product_id: { required },
        qty_plan: { required },
        price_plan: { required },
        qty_each_box: {}
      }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    status_spkb() {
      let status_spkb = 0;
      for (let i of this.spkb) {
        status_spkb = parseInt(i.status_spkb);
      }
      return status_spkb;
    },
    totalQtyActual() {
      let total = 0;
      for (let i of this.spkb_actual) {
        total += parseInt(i.qty);
      }
      return total;
    },
    totalPriceActual() {
      let totalPrice = 0;
      for (let i of this.spkb_actual) {
        totalPrice += ((parseInt(i.qty)) * i.price_plan);
      }
      return totalPrice;
    },
    getDriverName() {
      let driver_name = '';
      for (let i of this.spkb) {
        driver_name = i.driver_name;
      }
      return driver_name;
    },
    getInvoicePIC() {
      let invoice_pic = '';
      for (let i of this.spkb) {
        invoice_pic = (i.invoice_pic_employee_name === null) ? i.invoice_pic_dc_name : i.invoice_pic_employee_name;
        if(i.horeka_pic !== '') {
          invoice_pic = i.horeka_pic;
        }
      }
      return invoice_pic;
    },
    getDeliveryDate() {
      let delivery_date = '';
      for (let i of this.spkb) {
        delivery_date = moment(i.delivery_date).format('DD MMM YYYY');
      }
      return delivery_date;
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function(spkb_id) {
      this.loading = true;
      this.getDetailSpkb(spkb_id);
    },
    formatPrice: function(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getDetailSpkb: function(spkb_id) {
      this.axios
        //.get("mobile/dashboard/inventory/spkb-list-detail/" + spkb_id + "/")
        .get("web/spkb/spkb-list-detail/" + spkb_id + "/")
        .then(response => {
          let data = response.data.data;
          this.spkb = data;
          data.forEach((value, index) => {
            this.spkb_actual.push({
              order_type: value.order_type,
              qty: parseInt(value.qty_plan),
              product_id: value.product_id,
              qty_plan: value.qty_plan,
              price_plan: parseInt(value.price_plan),
              qty_each_box: parseInt(value.qty_each_box)
            });
            this.totalQty += parseInt(value.qty_plan);
          });
        })
        .catch(error => {
          this.expired(error, "Error Messages");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    doCancel: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah membatalkan SPKB ini ?")) {
        this.loadingSubmit = true;
        let reGroup = {};
        reGroup.spkb_number = this.spkb_number;
        this.axios
          .put("web/spkb/cancel-spkb/", reGroup)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Cancel SPKB",
                message: response.data.message
              });
              this.loadingSubmit = false;
              this.$router.push({ path: "/spkb-adjust/all" });
            }
          })
          .catch(error => {
            this.expired(error, "Error Messages");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    doSomething: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin memasukkan Qty Aktual ?")) {
        this.loadingSubmit = true;
        let tempVal = false;
        this.spkb_actual.map((x)=> {
          if(x.qty > parseInt(x.qty_plan)) {
            tempVal = true;
          }
        });

        if(tempVal) {
            alert('Your Quantity is more than qty plan')
            window.location.reload();
        } else {

          let reGroup = {};
          reGroup.spkb_number = this.spkb_number;
          reGroup.data = { order_detail: this.spkb_actual };
          reGroup.invocie_pic_customer = this.customers.value;
          this.axios
            .put("web/spkb/adjust-spkb/", reGroup)
            //.put("mobile/dashboard/inventory/adjust-spkb/", reGroup)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Adjust SPKB",
                  message: response.data.message
                });
                this.loadingSubmit = false;
                this.$router.push({ path: "/spkb-adjust/all" });
              }
            })
            .catch(error => {
              this.expired(error, "Error Messages");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.spkb_number = route[4];
    this.init(route[4]);
  }
};
</script>


<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>